export default [
  ['ffffff', 'White'],
  ['848484', 'Light Grey'],
  ['555555', 'Medium Grey'],
  ['323232', 'Dark Grey'],
  ['050505', 'Black'],
]
